import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Stars } from "@/components/site/Stars";
import { ChannelBadge, VerifiedBadge } from "@/components/site/ReviewMeta";

const SOURCES = ["All", "Google", "Airbnb", "VRBO"];

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [props, setProps] = useState([]);
  const [src, setSrc] = useState("All");
  const [prop, setProp] = useState("All");

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data.reviews));
    api.get("/properties").then((r) => setProps(r.data.properties));
  }, []);

  const filtered = reviews.filter((r) => (src === "All" || r.source === src) && (prop === "All" || r.property_id === prop));
  const nameOf = (id) => props.find((p) => p.id === id)?.name || "";

  return (
    <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
      <span className="overline">Reviews</span>
      <h1 className="mt-2 text-4xl lg:text-5xl">Real words from real guests</h1>
      <div className="mt-3 flex items-center gap-2 text-taupe"><Stars value={5} /> 4.93 average across 1,000+ verified stays</div>

      <div className="mt-8 flex flex-wrap gap-3">
        <div className="flex flex-wrap gap-2">
          {SOURCES.map((s) => (
            <button key={s} data-testid={`review-src-${s}`} onClick={() => setSrc(s)}
              className={`rounded-full border px-4 py-2 text-sm ${src === s ? "border-ink bg-ink text-white" : "border-black/10 text-ink hover:border-camel"}`}>{s}</button>
          ))}
        </div>
      </div>

      <div className="mt-4">
        <select data-testid="review-property" value={prop} onChange={(e) => setProp(e.target.value)}
          className="rounded-full border border-black/10 bg-white px-4 py-2 text-sm">
          <option value="All">All properties</option>
          {props.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
      </div>

      <div className="mt-8 columns-1 gap-6 sm:columns-2 lg:columns-3">
        {filtered.map((r) => (
          <div key={r.id} className="mb-6 break-inside-avoid rounded-3xl card-lux p-6">
            <div className="mb-2 flex items-center justify-between">
              <span className="font-medium text-ink">{r.author}</span>
              <ChannelBadge source={r.source} />
            </div>
            <Stars value={r.rating} size={13} />
            <p className="mt-3 text-ink/80">{r.text}</p>
            <div className="mt-3 flex items-center justify-between text-xs text-taupe">
              <span>{r.property_name || nameOf(r.property_id)} · {r.date}</span>
              {r.verified && <VerifiedBadge />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
